import { render, staticRenderFns } from "./DeviceValShortcutComponent.vue?vue&type=template&id=bfe1fbea&"
import script from "./DeviceValShortcutComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceValShortcutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports